// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FKWO","inner":"styles_inner__3frRy","right":"styles_right__yhM7R","close":"styles_close__2ptI8","footer":"styles_footer__1KEh_"};